class HandleAlert {
  constructor() {
    this.alertBar = document.querySelector(".alert-bar");
    this.siteHeader = document.querySelector(".home-header");
    this.events();
  }

  events() {
    if (this.alertBar) {
      const closeButton = this.alertBar.querySelector(".alert-bar__close");
      closeButton.addEventListener("click", () => this.closeAlert());

      if (this.siteHeader) {
        const alertBarHeight = this.alertBar.clientHeight;
        this.siteHeader.style.top = `${alertBarHeight}px`;
      }
    }
  }

  closeAlert() {
    if (this.alertBar) {
      this.alertBar.remove();
      if (this.siteHeader) {
        this.siteHeader.style.top = "0px";
      }
    }
  }
}

export default HandleAlert;
